/**
 * 客訂 Detail `salesOrders[]` → 嵌套表／預覽 Dialog。
 * 契約：`plannedShipDate`、`lines[]`（product／qty／remark；讀取相容舊 `shipQty`）。
 */

function mapPreviewLines(lines) {
  return (lines ?? []).map((line, index) => ({
    id: line?.id ?? `preview-line-${index}`,
    productName: line?.product?.name ?? '',
    productCode: line?.product?.productNo ?? '',
    qty: line?.qty ?? line?.shipQty,
    remark: line?.remark ?? '',
  }));
}

/**
 * @param {object} [row]
 */
export function mapCustomerOrderSalesOrderRow(row) {
  return {
    ...row,
    plannedShipDate: row?.plannedShipDate ?? row?.scheduledDate ?? '',
    previewLines: mapPreviewLines(row?.lines),
  };
}

/**
 * API 空陣列／缺陣列 → `[]`（畫面「尚無銷貨單」）。有列時不拿 mock 補排程日或品項。
 *
 * @param {object[]|null|undefined} apiRows
 * @returns {object[]}
 */
export function mapCustomerOrderSalesOrderRows(apiRows) {
  if (!Array.isArray(apiRows) || apiRows.length === 0) {
    return [];
  }

  return apiRows.map((row) => mapCustomerOrderSalesOrderRow(row));
}
